import { Card, Col, Row, Statistic, Typography } from 'antd';
import { PageHeader } from '@components/page-header/PageHeader';

export function DashboardPage() {
  return (
    <>
      <PageHeader
        title="Dashboard"
        subtitle="Snapshot of master-data health, pending actions, and configuration exceptions"
        breadcrumb={[{ label: 'Dashboard' }]}
      />
      <div style={{ padding: 24 }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <Card>
              <Statistic title="Active Superstores" value={1} suffix="of 1" />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card>
              <Statistic title="Active Child Hubs" value={0} suffix="of 0" />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card>
              <Statistic title="Pending Approvals" value={0} />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Card>
              <Statistic title="Configuration Exceptions" value={0} />
            </Card>
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
          <Col xs={24} lg={12}>
            <Card title="Recent Activity">
              <Typography.Text type="secondary">
                Activity feed will appear once audit events are wired up.
              </Typography.Text>
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card title="Pending Actions for You">
              <Typography.Text type="secondary">
                Approval queue summary will appear once the approvals feature is implemented.
              </Typography.Text>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}